module.exports = __webpack_public_path__ + "assets/img/message.1fbaa155.svg";